// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maintenance-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* 이미지 컨테이너 */
.maintenance-image-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
}

.maintenance-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* 텍스트 컨테이너 */
.maintenance-text-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.maintenance-content {
  text-align: center;
  color: white;
  max-width: 600px;
  padding: 40px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 25px 45px rgba(0, 0, 0, 0.1);
}

/* 아이콘 애니메이션 */
.maintenance-icon {
  margin-bottom: 30px;
}

.gear-icon {
  position: relative;
  display: inline-block;
}

.gear {
  font-size: 4rem;
  animation: rotate 3s linear infinite;
}

.gear-small {
  position: absolute;
  top: -10px;
  right: -10px;
  font-size: 2rem;
  animation: rotate-reverse 2s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes rotate-reverse {
  from {
    transform: rotate(360deg);
  }
  to {
    transform: rotate(0deg);
  }
}

/* 타이틀 스타일 */
.maintenance-title {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;
  background: linear-gradient(45deg, #fff, #e0e0e0);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.maintenance-subtitle {
  font-size: 1.4rem;
  margin-bottom: 30px;
  opacity: 0.9;
  line-height: 1.6;
}

/* 상세 정보 */
.maintenance-details {
  margin-bottom: 40px;
  opacity: 0.8;
}

.maintenance-details p {
  font-size: 1.1rem;
  margin: 10px 0;
  line-height: 1.5;
}

/* 연락처 정보 */
.contact-info {
  margin-bottom: 30px;
}

.contact-info p {
  font-size: 1rem;
  margin-bottom: 15px;
  opacity: 0.9;
}

.contact-details {
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
}

.contact-details span {
  background: rgba(255, 255, 255, 0.2);
  padding: 10px 20px;
  border-radius: 25px;
  font-size: 0.95rem;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

/* 로딩 애니메이션 */
.maintenance-animation {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 20px;
}

.dot {
  width: 12px;
  height: 12px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  animation: bounce 1.4s ease-in-out infinite both;
}

.dot:nth-child(1) { animation-delay: -0.32s; }
.dot:nth-child(2) { animation-delay: -0.16s; }

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

/* 로딩 상태 */
.maintenance-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  color: white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.maintenance-loading p {
  font-size: 1.2rem;
  opacity: 0.9;
}

/* 반응형 디자인 */
@media (max-width: 768px) {
  .maintenance-content {
    padding: 30px 20px;
    margin: 20px;
  }
  
  .maintenance-title {
    font-size: 2.2rem;
  }
  
  .maintenance-subtitle {
    font-size: 1.2rem;
  }
  
  .contact-details {
    flex-direction: column;
    gap: 15px;
  }
  
  .gear {
    font-size: 3rem;
  }
  
  .gear-small {
    font-size: 1.5rem;
  }
}

@media (max-width: 480px) {
  .maintenance-title {
    font-size: 1.8rem;
  }
  
  .maintenance-subtitle {
    font-size: 1rem;
  }
  
  .maintenance-details p {
    font-size: 1rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/css/MaintenancePage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4DAA4D;AAC9D;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA,cAAc;AACd;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;EACjD,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA,aAAa;AACb;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA,oBAAoB,uBAAuB,EAAE;AAC7C,oBAAoB,uBAAuB,EAAE;;AAE7C;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,4DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,YAAY;AACZ;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".maintenance-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n/* 이미지 컨테이너 */\n.maintenance-image-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #000;\n}\n\n.maintenance-image {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n/* 텍스트 컨테이너 */\n.maintenance-text-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.maintenance-content {\n  text-align: center;\n  color: white;\n  max-width: 600px;\n  padding: 40px;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 25px 45px rgba(0, 0, 0, 0.1);\n}\n\n/* 아이콘 애니메이션 */\n.maintenance-icon {\n  margin-bottom: 30px;\n}\n\n.gear-icon {\n  position: relative;\n  display: inline-block;\n}\n\n.gear {\n  font-size: 4rem;\n  animation: rotate 3s linear infinite;\n}\n\n.gear-small {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  font-size: 2rem;\n  animation: rotate-reverse 2s linear infinite;\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes rotate-reverse {\n  from {\n    transform: rotate(360deg);\n  }\n  to {\n    transform: rotate(0deg);\n  }\n}\n\n/* 타이틀 스타일 */\n.maintenance-title {\n  font-size: 3rem;\n  font-weight: 700;\n  margin-bottom: 20px;\n  background: linear-gradient(45deg, #fff, #e0e0e0);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n}\n\n.maintenance-subtitle {\n  font-size: 1.4rem;\n  margin-bottom: 30px;\n  opacity: 0.9;\n  line-height: 1.6;\n}\n\n/* 상세 정보 */\n.maintenance-details {\n  margin-bottom: 40px;\n  opacity: 0.8;\n}\n\n.maintenance-details p {\n  font-size: 1.1rem;\n  margin: 10px 0;\n  line-height: 1.5;\n}\n\n/* 연락처 정보 */\n.contact-info {\n  margin-bottom: 30px;\n}\n\n.contact-info p {\n  font-size: 1rem;\n  margin-bottom: 15px;\n  opacity: 0.9;\n}\n\n.contact-details {\n  display: flex;\n  justify-content: center;\n  gap: 30px;\n  flex-wrap: wrap;\n}\n\n.contact-details span {\n  background: rgba(255, 255, 255, 0.2);\n  padding: 10px 20px;\n  border-radius: 25px;\n  font-size: 0.95rem;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n/* 로딩 애니메이션 */\n.maintenance-animation {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 20px;\n}\n\n.dot {\n  width: 12px;\n  height: 12px;\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 50%;\n  animation: bounce 1.4s ease-in-out infinite both;\n}\n\n.dot:nth-child(1) { animation-delay: -0.32s; }\n.dot:nth-child(2) { animation-delay: -0.16s; }\n\n@keyframes bounce {\n  0%, 80%, 100% {\n    transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n  }\n}\n\n/* 로딩 상태 */\n.maintenance-loading {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  color: white;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 5px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: white;\n  animation: spin 1s ease-in-out infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.maintenance-loading p {\n  font-size: 1.2rem;\n  opacity: 0.9;\n}\n\n/* 반응형 디자인 */\n@media (max-width: 768px) {\n  .maintenance-content {\n    padding: 30px 20px;\n    margin: 20px;\n  }\n  \n  .maintenance-title {\n    font-size: 2.2rem;\n  }\n  \n  .maintenance-subtitle {\n    font-size: 1.2rem;\n  }\n  \n  .contact-details {\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .gear {\n    font-size: 3rem;\n  }\n  \n  .gear-small {\n    font-size: 1.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .maintenance-title {\n    font-size: 1.8rem;\n  }\n  \n  .maintenance-subtitle {\n    font-size: 1rem;\n  }\n  \n  .maintenance-details p {\n    font-size: 1rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
